import React, { useEffect } from 'react';
import Header from '.././Elements/Header';

import BodyClassSetter from '../Elements/BodyClassSetter';
import MarketView from "../Elements/MarketView";
import Footer from "../Elements/Footer";

import { useViewStore } from '../store';

const MarketShareView = () => {    
    
    const setView = useViewStore((state) => state.setView);
    
    useEffect(() => {
        setView('MarketShareView');
    }, [setView]);

    return (
        <BodyClassSetter>
            <Header title="P&I Market Review 2024"/>
            <MarketView />
            <Footer />
        </BodyClassSetter>
    )
}

export default MarketShareView;